// extracted by mini-css-extract-plugin
export default {"menuItem":"SelectItemFilters_menuItem__RJSgS","title":"SelectItemFilters_title__NqAEi"};